import peggyPic from "@/public/images/artists/peggy.png";
import { Artist } from "@/types/types";

export const peggy = {
  id: "138",
  name: "Peggy",
  image: peggyPic,
  description: `Peggy's voice is deep and unwavering, with a powerful and soulful resonance. She brings a commanding presence to every performance. Her rich tones are perfectly suited for soul, gospel, and blues, adding depth and intensity to every track.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fpeggy-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: [
        "Soul",
        "Folk",
        "Dance",
        "Jazz",
        "Unprocessed",
        "Indie",
        "Mature",
        "Deep",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 53,
        high: 73,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
